import * as React from "react";
import { Weight, Wind, Clock, Leaf } from "lucide-react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
const facts = [{
  id: "mortgage",
  icon: Weight,
  stat: "4.2",
  unit: "min",
  title: "Mortgage Estimator",
  summary: "Calculate monthly payments and amortization schedules instantly.",
  details: "Our mortgage tool provides a comprehensive breakdown of principal, interest, taxes, and insurance. It includes dynamic charts to visualize your equity growth over 15, 20, or 30-year terms, helping you make informed home-buying decisions with precision data."
}, {
  id: "bmi",
  icon: Wind,
  stat: "1.5",
  unit: "min",
  title: "Health BMI Tracker",
  summary: "Quickly assess body mass index and health category ranges.",
  details: "The BMI calculator uses standardized medical formulas to determine your weight-to-height ratio. It provides immediate feedback on health categories and offers links to related calorie and macro-nutrient calculators for a holistic view of your wellness journey."
}, {
  id: "currency",
  icon: Clock,
  stat: "0.8",
  unit: "min",
  title: "Global Currency",
  summary: "Real-time exchange rates for over 150 global currencies.",
  details: "Stay updated with live market data. This tool allows for multi-currency comparisons and historical rate tracking. Perfect for travelers and international business professionals who require high-precision financial conversions on the fly."
}, {
  id: "percentage",
  icon: Leaf,
  stat: "0.5",
  unit: "min",
  title: "Quick Percentage",
  summary: "Solve complex percentage increases, decreases, and ratios.",
  details: "The most used tool in our suite. Whether you are calculating a tip, a retail discount, or a year-over-year growth percentage, this calculator provides the result and the underlying formula to ensure you understand the mathematical logic."
}];
export default function BisonFastFacts() {
  return <section data-section-id="236782" id="recently-used" className="bg-secondary text-foreground py-24 px-6 md:px-12 lg:px-24">
      <div className="mx-auto max-w-3xl">
        <div className="mb-20 text-center">
          <h2 className="font-default text-primary mb-4 text-sm font-bold tracking-widest uppercase">
            Your Activity
          </h2>
          <p className="font-default text-foreground text-3xl font-semibold md:text-4xl">
            Recently Used Tools
          </p>
        </div>

        <div className="flex flex-col gap-[60px]">
          {facts.map((fact, i) => <div key={fact.id} data-index={i} className="flex flex-col items-center text-center">
              <div className="mb-6 flex flex-col items-center gap-3">
                <fact.icon className="text-primary size-12" strokeWidth={1.5} aria-hidden="true" />
                <div className="text-primary flex items-baseline gap-1">
                  <span className="font-mono text-6xl font-bold tracking-tighter">
                    {fact.stat}
                  </span>
                  <span className="font-mono text-2xl font-medium tracking-normal">
                    {fact.unit}
                  </span>
                </div>
              </div>

              <h3 className="font-default text-foreground mb-4 text-[22.4px] font-bold leading-tight">
                {fact.title}
              </h3>

              <p className="font-default text-muted-foreground mb-8 max-w-xl text-lg leading-relaxed">
                {fact.summary}
              </p>

              <Accordion type="single" collapsible className="w-full max-w-xl">
                <AccordionItem value="details" className="border-border border-t-0 border-b">
                  <AccordionTrigger className="hover:bg-primary/5 text-primary justify-center gap-3 rounded-lg px-4 py-3 transition-colors hover:no-underline">
                    <span className="font-default text-xs font-bold tracking-wider uppercase">
                      Resume Calculation
                    </span>
                  </AccordionTrigger>
                  <AccordionContent className="font-default text-foreground pt-6 pb-8 text-left text-base leading-relaxed">
                    <div className="bg-background border-border rounded-md border p-4 shadow-sm">
                      {fact.details}
                    </div>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
            </div>)}
        </div>
      </div>
    </section>;
}